<app-dialog [config]="data.confirmationData.getConfig()" (actionButtonClicked)="onActionButtonClicked($event)">
    <ng-container dialog-title>
        <span [innerHTML]="data.confirmationData.caption|sanitizeHtml"></span>
    </ng-container>
    <ng-container dialog-process-in-progress>
        <div class="mb-2 d-flex justify-content-center">
            <p [innerHTML]="data.confirmationData.question|sanitizeHtml"></p>
        </div>
    </ng-container>
</app-dialog>
